import { render } from "./EmployerForm.vue?vue&type=template&id=a8d7e36a&scoped=true"
import script from "./EmployerForm.vue?vue&type=script&lang=js"
export * from "./EmployerForm.vue?vue&type=script&lang=js"

import "./EmployerForm.vue?vue&type=style&index=0&id=a8d7e36a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d7e36a"]])

export default __exports__